import {
  Avatar,
  Box,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";

const WhyCodingSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const BoxMotion = motion(Box);
  const TypographyMotion = motion(Typography);

  const cardsInformation = [
    {
      logoUrl: "/images/deepcomprehensive.png",
      title: "Deep & Comprehensive",
      description:
        "Presentation of in-depth and comprehensive analysis is our expertise. We'll present the analysis in a way that is easy to understand",
    },
    {
      logoUrl: "/images/seocentric.png",
      title: "SEO Centric Company",
      description:
        "Coding Forge is an SEO-Centric company focus on helping businesses to improve their SEO. Every client will get end-to-end services",
    },
    {
      logoUrl: "/images/localizedseo.png",
      title: "Localized SEO",
      description:
        "Every business is unique, and so is our approach. Localized SEO offers a more effective strategy to reach the right target market",
    },
  ];

  return (
    <Box
      sx={{
        backgroundImage: `url('/images/firstbackground.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        mx: { xs: "1rem", sm: "2rem", md: "3rem", lg: "5rem" },
        borderRadius: { xs: "2rem", sm: "3rem", md: "4rem" },
        mt: { xs: "0.5rem", sm: "0.8rem", md: "1rem" },
        mb: { xs: "3rem", sm: "4rem", md: "5rem" },
      }}
    >
      <TypographyMotion
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.2 }}
        variant="h2"
        sx={{
          textAlign: "center",
          px: { xs: "1.5rem", sm: "5rem", md: "10rem", lg: "30rem" },
          pt: { xs: "3rem", sm: "4rem", md: "5rem", lg: "6rem" },
          pb: { xs: "1.5rem", sm: "2rem", md: "3rem" },
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontStyle: "normal",
          color: "rgb(0, 0, 0)",
          fontSize: { xs: "2.2rem", sm: "2.8rem", md: "3rem", lg: "48px" },
          lineHeight: { xs: "2.6rem", sm: "3.2rem", md: "3.6rem", lg: "58px" },
        }}
      >
        Why Coding Forge is your best choice
      </TypographyMotion>
      <TypographyMotion
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.2 }}
        variant="h5"
        sx={{
          textAlign: "center",
          px: { xs: "1.5rem", sm: "3rem", md: "5rem" },
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontStyle: "normal",
          color: "rgb(0, 0, 0)",
          fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem", lg: "24px" },
          lineHeight: { xs: "1.6rem", sm: "2rem", md: "2.2rem", lg: "36px" },
        }}
      >
        Coding Forge is a reliable and affordable website building tool that
      </TypographyMotion>
      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        spacing={{ xs: 2, sm: 3, md: 4 }}
        sx={{
          py: { xs: "2rem", sm: "3rem", md: "4rem" },
          px: { xs: "1.5rem", sm: "2rem", md: "3rem", lg: "4rem" },
          justifyContent: "center",
          alignItems: { xs: "center", md: "stretch" },
        }}
      >
        {cardsInformation.map((card, i) => (
          <BoxMotion
            initial={{ opacity: 0, x: isMobile ? 50 : 150 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{
              duration: 1,
              delay: i * (isMobile ? 0.3 : 0.5),
            }}
            key={i}
            sx={{
              px: { xs: "1.8rem", sm: "2.2rem", md: "2.6rem" },
              py: { xs: "2.2rem", sm: "2.8rem", md: "3.2rem" },
              backgroundColor: "#ffffff",
              borderRadius: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              width: { xs: "100%", sm: "80%", md: "33%" },
              maxWidth: { xs: "350px", md: "none" },
            }}
          >
            <Avatar
              sx={{
                width: { xs: "3.5rem", sm: "4rem", md: "5rem" },
                height: { xs: "3.5rem", sm: "4rem", md: "5rem" },
              }}
            >
              <img
                style={{
                  width: isMobile ? "1.8rem" : isTablet ? "2.2rem" : "2.4rem",
                  height: isMobile ? "1.8rem" : isTablet ? "2.2rem" : "2.4rem",
                }}
                src={card.logoUrl}
                alt="logo"
              />
            </Avatar>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "600",
                pt: { xs: "2rem", sm: "2.8rem", md: "3.6rem" },
                pb: { xs: "0.8rem", sm: "1rem", md: "1.2rem" },
                fontSize: {
                  xs: "1.3rem",
                  sm: "1.4rem",
                  md: "1.5rem",
                  lg: "1.6rem",
                },
              }}
            >
              {card.title}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: "rgba(0,0,0,0.6)",
                lineHeight: { xs: "1.6rem", sm: "1.8rem", md: "2rem" },
                letterSpacing: ".1rem",
                fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                wordSpacing: ".1rem",
              }}
            >
              {card.description}
            </Typography>
          </BoxMotion>
        ))}
      </Stack>
    </Box>
  );
};

export default WhyCodingSection;
